import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { MobileNoteEditorSlice } from "./types";
import type { NotesTableItem } from "@/features/NotesManager/model";

const initialState: MobileNoteEditorSlice = {
  currentNote: null,
  edit: false,
};

export const mobileNoteEditorSlice = createSlice({
  name: "mobileEditor",
  initialState,
  reducers: {
    setNote(state, action: PayloadAction<NotesTableItem>) {
      state.currentNote = action.payload;
    },
    setEdit(state, action: PayloadAction<boolean>) {
      state.edit = action.payload;
    },
  },
  selectors: {
    getCurrentNote: (state: MobileNoteEditorSlice) => state.currentNote,
    getEdit: (state: MobileNoteEditorSlice) => state.edit,
  },
});

export const { actions: mobileNoteEditorSliceActions, selectors: mobileNoteEditorSliceSelectors } =
  mobileNoteEditorSlice;
